import React, { useEffect, useState } from 'react'
import InputMask from 'react-input-mask'
import api from '../components/api'
import { useHistory } from 'react-router-dom'
import ModalSenhaAdm from '../modals/senhaAdm'
import { validaCPF } from '../components/functions'


const Usuario = (props) => {

    

    async function verificaPermissao() {


        if (sessionStorage.getItem('permAdmin') != 'true') {

            history.push('/')

        }


    }
    

    const history = useHistory()

    var [us_codigo, setUs_codigo] = useState(props.match.params.usuario_id)
    var [cpf, setCPF] = useState('')
    var [nome, setNome] = useState('')
    var [email, setEmail] = useState('')
    var [telefone, setTelefone] = useState('')
    var [inativo, setInativo] = useState()
    var [funcao, setFuncao] = useState('')
    var [login, setLogin] = useState('')

    var [permPaginas, setPermPaginas] = useState(false)
    var [permNoticias, setPermNoticias] = useState(false)
    var [permEventos, setPermEventos] = useState(false)
    var [permDesafios, setPermDesafios] = useState(false)
    var [permAdesoes, setPermAdesoes] = useState(false)
    var [permAdmin, setPermAdmin] = useState(false)
    var [permSenhaInst, setPermSenhaInst] = useState(false)

    var [senha, setSenha] = useState('')
    var [confirmaSenha, setConfirmaSenha] = useState('')


    function carregaDados() {

        if (!isNaN(us_codigo)) {


            api.get(`usuario/${us_codigo}`).then((result) => {

                var data = result.data[0]
                console.log(data)
                
                
                setCPF(data.cpf ? data.cpf : '')
                setNome(data.us_nome)
                setEmail(data.email ? data.email : '')
                setInativo(data.inativo)
                setFuncao(data.funcao ? data.funcao : '')
                setLogin(data.us_login)
                setPermAdesoes(data.permAdesoes == null ? false : data.permAdesoes)
                setPermPaginas(data.permPaginas == null ? false : data.permPaginas)
                setPermNoticias(data.permNoticias == null ? false : data.permNoticias)
                setPermEventos(data.permEventos == null ? false : data.permEventos)
                setPermDesafios(data.permDesafios == null ? false : data.permDesafios)
                setPermAdmin(data.permAdmin == null ? false : data.permAdmin)
                setPermSenhaInst(data.permSenhaInst == null ? false : data.permSenhaInst)

            }).catch((err) => {

                console.log(err.response)

            })




        }


    }


    function salvaUsuario() {

        if (isNaN(us_codigo)) {


            if (senha != confirmaSenha) {

                window.toastr.error('Senhas não conferem!')
                return false

            }


        }

        if (cpf != null && cpf != '') {

            if (!validaCPF(cpf.replaceAll('-', '').replaceAll('.',''))) {

                window.toastr.error('<b>CPF</b> inválido!')
                return false;

            }

            
        }


        if (login == '') {

            window.toastr.error('Por favor, informe o login!')
            return false

        }


        

        //console.log(dataPost)

         window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    
                    if (!isNaN(us_codigo)) {


                        var dataPost = {

                            nome: nome,
                            inativo: inativo,
                            email: email,
                            cpf: cpf.replaceAll('-', '').replaceAll('.',''),
                            funcao: funcao,
                            permPaginas: permPaginas,
                            permNoticias: permNoticias,
                            permEventos: permEventos,
                            permDesafios: permDesafios,
                            permAdesoes: permAdesoes,
                            permAdmin: permAdmin,
                            telefone: telefone,
                            us_login: login,
                            permSenhaInst: permSenhaInst,
                
                        }


                        api.put(`usuario/${us_codigo}`, dataPost).then((result) => {
                            console.log(result.data)
    
                            window.toastr.success('Salvo com sucesso!')
    
                        }).catch((err) => {
                            console.log(err.response)
                        })


                    } else {


                        var dataPost = {

                            nome: nome,
                            inativo: inativo,
                            email: email,
                            cpf: cpf.replaceAll('-', '').replaceAll('.',''),
                            funcao: funcao,
                            permPaginas: permPaginas,
                            permNoticias: permNoticias,
                            permEventos: permEventos,
                            permDesafios: permDesafios,
                            permAdesoes: permAdesoes,
                            permAdmin: permAdmin,
                            permSenhaInst: permSenhaInst,
                            telefone: telefone,
                            us_senha: senha,
                            us_login: login,
                            ad_usr: sessionStorage.getItem('us_codigo'),
                
                        }

                        //console.log(dataPost)
                        //return false

                        api.post('usuario', dataPost).then((result) => {

                            var data = result.data[0]

                            if (data) {

                                setUs_codigo(data.us_codigo)
                                window.toastr.success('Salvo com sucesso!')

                            }

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    }

                    

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }


    useEffect(() => {

        verificaPermissao()
        carregaDados()

    }, [])


    return (


        <div>
            
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-users'></i>
                </div>
                <div class='header-title'>
                    <h1>Usuário</h1>
                    <small>Administração</small>
                    
                </div>
            </div>

            <div class="row">
                
                <div class="col-sm-12">
                    


                    <ul class="nav nav-tabs">
                            <li class="active"><a href="#tab1" data-toggle="tab">Cadastro</a></li>
                            <li><a href="#tab2" data-toggle="tab">Permissões</a></li>
                            
                        </ul>
                        
                        <div class="tab-content">
                            <div class="tab-pane fade in active" id="tab1">
                                <div class="panel-body">
                                        

                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>CPF</label>
                                            <InputMask mask="999.999.999-99" class="form-control" placeholder="" value={cpf} onChange={event => setCPF(event.target.value)} />
                                                            
                                        </div>
                                    </div>

                                    <div class="col-md-9">
                                        <div class="form-group">
                                            <label>Nome</label>
                                            <input type="text" class="form-control" placeholder="" value={nome} onChange={event => setNome(event.target.value)} />
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Login</label>
                                            <input type="text" class="form-control" placeholder="" value={login} onChange={event => setLogin(event.target.value)} />
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label>Função</label>
                                            <input type="text" class="form-control" placeholder="" value={funcao} onChange={event => setFuncao(event.target.value)} />
                                                            
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>E-mail</label>
                                            <input type="text" class="form-control" placeholder="" value={email} onChange={event => setEmail(event.target.value)} />
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>DDD + Telefone</label>
                                            <InputMask mask="(99) 99999-9999" class="form-control" placeholder="" value={telefone} onChange={event => setTelefone(event.target.value)} />
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>Inativo</label>
                                            <select class="form-control" value={inativo} onChange={event => setInativo(event.target.value)} >
                                                <option value={false}>Não</option>
                                                <option value={true}>Sim</option>
                                            </select>
                                                            
                                        </div>
                                    </div>
                                    

                                    <div class="col-md-6" style={{ display: !isNaN(us_codigo) ? 'none' : 'table-row'}}>
                                        <div class="form-group">
                                            <label>Senha</label>
                                            <input type="password" style={{ backgroundColor: '#e1faf1'}} class="form-control" placeholder="" value={senha} onChange={event => setSenha(event.target.value)} />
                                                            
                                        </div>
                                    </div>
                                    <div class="col-md-6" style={{ display: !isNaN(us_codigo) ? 'none' : 'table-row'}}>
                                        <div class="form-group">
                                            <label>Confirma senha</label>
                                            <input type="password" style={{ backgroundColor: '#e1faf1'}} class="form-control" placeholder="" value={confirmaSenha} onChange={event => setConfirmaSenha(event.target.value)} />
                                                            
                                        </div>
                                    </div>
                                    
                                  


                                </div>
                            </div>
                            <div class="tab-pane fade" id="tab2">
                                <div class="panel-body">
                                    
                                    <div className="table-responsive">
                                        <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th width="80">&nbsp;</th>
                                                    <th>Acesso</th>                                                   
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <center>
                                                        <input type="checkbox" onClick={event => setPermPaginas(event.target.checked)} checked={ permPaginas ? true : false} />
                                                        </center>
                                                    </td>
                                                    <td>
                                                        Páginas e Conteúdo
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <center>
                                                        <input type="checkbox" onClick={event => setPermNoticias(event.target.checked)} checked={ permNoticias ? true : false} />
                                                        </center>
                                                    </td>
                                                    <td>
                                                        Notícias
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <center>
                                                        <input type="checkbox" onClick={event => setPermEventos(event.target.checked)} checked={ permEventos ? true : false} />
                                                        </center>
                                                    </td>
                                                    <td>
                                                        Eventos
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <center>
                                                        <input type="checkbox"  onClick={event => setPermDesafios(event.target.checked)} checked={ permDesafios ? true : false} />
                                                        </center>
                                                    </td>
                                                    <td>
                                                        Desafios
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <center>
                                                        <input type="checkbox"  onClick={event => setPermAdesoes(event.target.checked)}  checked={ permAdesoes ? true : false} />
                                                        </center>
                                                    </td>
                                                    <td>
                                                        Adesões
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <center>
                                                        <input type="checkbox" onClick={event => setPermSenhaInst(event.target.checked)}  checked={ permSenhaInst ? true : false} />
                                                        </center>
                                                    </td>
                                                    <td>
                                                        Gestão de senha de Adesão Institucional
                                                    </td>                                                
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <center>
                                                        <input type="checkbox" onClick={event => setPermAdmin(event.target.checked)}  checked={ permAdmin ? true : false} />
                                                        </center>
                                                    </td>
                                                    <td>
                                                        Administração
                                                    </td>                                                
                                                </tr>
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>

                                </div>
                            </div>
                            
                    </div>
                                

                        
                </div>

                <div class="col-md-12">

                    <br/>
                                    
                    <button type="button" class="btn btn-info" onClick={() => history.push('/Usuarios')}>Voltar</button>&nbsp;
                    <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalAlteraSenhaAdm" style={{ display: !isNaN(us_codigo) ? "table-row" : 'none'}}>Alterar senha</button>&nbsp;
                    <button type="button" class="btn btn-primary" onClick={() => salvaUsuario()}>Salvar</button>
                </div>


                

            </div>


            <ModalSenhaAdm us_codigo={us_codigo} />
        
        </div>

    )

}

export default Usuario